/**
 * Normalized vertical alignment for a table cell value.
 * The API may return an empty string when verticalAlign is not set; treat that as middle.
 * @param {TableCellValueObjectCustom | null | undefined} cellValue
 * @returns {VerticalAlign}
 */
export function getEffectiveCellVerticalAlign(cellValue) {
  return cellValue?.verticalAlign?.length ? cellValue.verticalAlign : 'middle';
}

/**
 * @param {TableCellValueObjectCustom | null | undefined} cellValue
 * @returns {Align}
 */
export function getEffectiveCellAlign(cellValue) {
  return cellValue?.align ?? 'left';
}

/**
 * CSS `text-decoration` value from API strikeThrough / underline flags.
 * @param {ApiManagerTableColumnHeaderTextDecoration | null | undefined} textDecoration
 * @returns {string | undefined}
 */
export function getCssTextDecoration(textDecoration) {
  const td = textDecoration ?? { strikeThrough: false, underline: false };
  const value = [
    td.strikeThrough ? 'line-through' : null,
    td.underline ? 'underline' : null,
  ].filter(Boolean).join(' ');
  return value || undefined;
}

/**
 * CSS `opacity` from API cell opacity (0–1). Opaque cells omit inline opacity so row-level
 * styles (e.g. optimistic delete) are not overridden.
 * @param {number | null | undefined} opacity
 * @returns {number | undefined}
 */
export function getCssCellOpacity(opacity) {
  if (opacity == null || !Number.isFinite(opacity)) {
    return undefined;
  }
  if (opacity >= 1 || opacity < 0) {
    return undefined;
  }
  return opacity;
}
